// 按页面划分
export default {
    // 公共页面
    common: {
        detail: 'Détails',
        confirm: 'D\'accord',
        cancel: 'Annuler',
        no_data: 'Aucune donnée disponible',
        no_data_text: 'Il n\'y a actuellement aucune donnée à afficher ',
        network_error: 'Une erreur s\'est produite',
        network_error_text: 'Nous nous efforçons de la résoudre, veuillez réessayer plus tard.',
        network_contact: 'Nous contacter',
        refresh: 'Rafraîchir',
    },
    pullCom: {
        pull: 'Faire glisser pour actualiser',
        release: 'Relâcher pour actualiser',
        refresh: 'Actualisation en cours…',
    },
    index: {
        searchTip: 'Recherche Pays/Région',
        exclusiveTit: 'Offre exclusive',
        more: 'Quoi de plus',
        mainlandTit: 'Chine continentale',
        hkPackageTit: 'Hong Kong (China) packages',
        popularDestTit: 'Popular destinations',
        countryList: {
            cn: 'Mainland China',
            singapore: 'Singapore',
            hk: 'Hong Kong(China)',
            us: 'United States',
            thailand: 'Thailand',
            germany: 'Germany',
            italy: 'Italy',
            more: 'Quoi de plus'
        },
        regionalPackage: 'Forfaits de données transrégionaux',
        recommendPackage: 'Nous vous proposons',
        from: 'à partir de',
        guide: 'Guide d\'utilisation pour les débutants',
        sepcialArea: 'Zone',
        lastUpdate: 'dernière mise à jour',
        successRefresh: 'Actualisation terminée',
    },
    packages: {
        sub_title: {
            us: 'À l\'exclusion de Guam et Saipan',
            it: 'applicable au Vatican, à Saint-Marin',
            va: 'applicable en Italie, à Saint-Marin ',
            sm: 'applicable en Italie, au Vatican ',
            ma: 'Sahara occidental inclus',
            eh: 'applicable au Maroc',
            ch: 'Liechtenstein inclus',
            li: 'applicable en Suisse ',
            fr: 'Monaco inclus',
            mc: 'applicable en France',
            fi: 'Aland inclus',
            ax: 'applicable en Finlande ',
            gu: 'applicable à Saipan ',
            mp: 'applicable à Guam '
        },
        unlimited_packages: 'Forfait illimité de données',
        normal_packages: 'Forfait classique de données',
        multi_region_packages: 'Forfait interrégional comprenant {area} ',
        sale_text: 'Remise',
        high_speed_text: ' Internet Haut Débit',
        high_speed_text_year: 'Volume de données à haut débit par mois',
        periodUnit: {
            day: 'journée',
            month: 'Par mois',
            hour: 'Heure',
            year: 'Année',
        },
        periodUnits: {
            day: 'journée',
            month: 'Par mois',
            hour: 'Heure',
            year: 'Année',
        },
        periodUnitSimp: {
            day: 'journée',
            month: 'Par mois',
            hour: 'Heure',
            year: 'Année'
        },
        periodUnitsSimp: {
            day: 'journée',
            month: 'Par mois',
            hour: 'Heure',
            year: 'Année'
        },
        unlimited_good_name: {
            day: 'Illimité par jour',
            month: 'Illimité par mois',
            year: 'Illimité par an'
        },
        day_invalid: 'Expire dans la journée',
        month_invalid: 'Expire dans le mois en cours',
        immediate_valid: 'Immédiatement opérationnel',
        tomorrow_day_valid: 'Activer demain',
        tomorrow_month_valid: 'Activer le mois prochain',
    },
    point: {
        title: 'Mes points',
        point_history: 'Détails des points',
        my_point: 'Mes points',
        will_expire_on: 'Les points sont valables jusqu\'au',
        total: 'au total',
        more: 'Quoi de plus',
        redeem_for_package: 'Convertir en volume de données',
        redeem_for_balance: 'Limite de conversion',
        redeem_for_coupon: 'Coupons de conversion',
        points: 's\'inscrire',
        signIn:"Enregistrement",
        getPrizes:"Gagner des Prix",
        getPoint:" Gagner des points",
        lottery:"Points & Récompenses",
        dataPlans: "Échanger des données",
        Balance: "Échanger le solde",
        coupon: "Échanger des coupons",
        getPrizes:"Remporter un grand prix",
        membership_point_rules: 'Instructions d\'utilisation des points de membre',
        got_it: 'OK',
        tabs: {
            all: 'Tous les bundles',
            earn: 'obtenir',
            redeem: 'Remboursement'
        },
        upgradeApp:"Veuillez mettre à jour vers la dernière version de l'application",
    },
    member: {
        membership: 'membre',
        hello_member: 'Bonjour, cher membre',
        update: 'Surclassement',
        vip_member_benefits: 'Privilèges des membres VIP',
        packages: 'Data bundle',
        discounts: 'DISCOUNT!',
        points: 'Points',
        membership_policy: 'Accord d\'adhésion',
        faq: 'Questions frquentes',
        update_to_vip_membership: 'S\'inscrire en tant que membre VIP',
        vip_member: 'membre VIP',
        valid_till: 'Valid till',
        renew: 'Renouvellement',
        months: 'Par mois',
        payment: 'Confirmation de commande',
        vip_membership: 'membre VIP',
        enjoy_vip_member_benefits: 'Profitez des privilèges des membres VIP {len} !',
        by_purchasing_you_agree_to: 'Tout achat implique le consentement',
        coupon: 'Remise',
        available_coupon: '{num} disponible(s)',
        no_available_coupon: 'Aucun coupon disponible',
        actual_price: 'Montant payé',
        payment_success_text: 'Une fois l\'achat réussi, le forfait de données correspondant peut être automatiquement crédité sur le compte. ',
        balance: 'Solde',
        online_payment: 'Paiements en ligne',
        faq_title: 'Questions frquentes',
        policy_title: 'Confidentialité des membres',
        introduce_title: 'Instructions pour les membres'
    },
    order: {
        periodUnit: {
            day: 'journée',
            month: 'Par mois',
            year: 'Année'
        },
        periodUnits: {
            day: 'journée',
            month: 'Par mois',
            year: 'Année'
        },
        balance_payment_dialog: {
            title: 'Confirmer le paiement',
            content: 'Paiement depuis votre solde',
            noSelectPackageTitle: 'Aucun plan sélectionné',
            noSelectPackageContent: 'Choisissez d\'abord un package',
        },
        purcase_successful: 'Purchase Successful',
        vip_membership: 'membre VIP',
        total: 'montant du paiement',
        finish_btn: 'Revenir',
        get_order_status: 'Getting the order status, please wait...',
        order_status_tip: 'En attente de confirmation',
        order_status_note_user: 'Le paiement par carte bancaire/ carte de crédit n\'est pas autorisé. Veuillez contacter notre service clientèle.',
        order_status_btn_text: 'complètement',
        ios_iap_pay_btn: 'paiement immédiat'
    },
    faq: {
        page_title: 'Questions frquentes',
        mydevice: 'Mes appareils',
        more: 'plus d\'appareils',
        more_faq: 'plus de questions',
        all_device: 'tous les appareils',
        faq_detail: 'Détails',
    },
    device: {
        page_title: 'Guide d\'utilisation des appareils',
    },
    vpn: {
        page_title: 'Foire aux questions VPN',
        faq_detail: 'Détails',
    },
    eism: {
        page_title: 'Foire aux questions ESIM',
        faq_detail: 'ESIM Détails',
    },
    /*
    deviceGuide: {
        title: '请选择你的设备',
        skip: '跳过',
    },
    give_set: {
        give_set_page_title: '赠送流量设置',
        give_set_page_set_btn: '保存',
        title: '会员赠送套餐设置',
        desc: '升级会员成功后，我们将会定期赠送流量包至您设置的设备上，未绑定设备将不能接收赠送流量包！',
        select_device_placeholder: '请选择设备',
        select_device_title: '选择设备',
        no_device_title: '你还未绑定设备',
        no_device_desc: '请选择绑定设备类型',
        bind_type_by_scan: '扫一扫',
        bind_type_by_type: '按类型',
        disable_device_desc: '赠送流量包无法在您绑定的设备上使用，请绑定对应的设备',
        bind_device: '绑定设备',
        give_set_success: '设置成功',
        give_set_leave_desc: '当前设置未保存，确定离开当前页面吗？',
        give_guide_tip: '点击这里可编辑赠送流量设置哦！',
        get_it: '知道了',
        give_set_saved: '保存成功'
    }
    */
    deviceGuide: {
        title: 'Please select your device',
        skip: 'Skip',
    },
    give_set: {
        give_set_page_title: 'Complimentary traffic setting',
        give_set_page_set_btn: 'Save',
        title: 'Complimentary package setting for members',
        desc: 'After upgrading to member, we will send the data package to your device on a regular basis except unbound devices!',
        select_device_placeholder: 'Please select the device',
        select_device_title: 'Select the device',
        no_device_title: 'You haven’t bind device yet',
        no_device_desc: 'Please select a device type for binding',
        bind_type_by_scan: 'Scan',
        bind_type_by_type: 'Model',
        disable_device_desc: 'The complimentary traffic packet can\'t be used on the device which you bound. Please bind the corresponding device',
        bind_device: 'Bind device',
        give_set_success: 'Set Successfully',
        give_set_leave_desc: 'Your settings are not saved, are you sure to leave the current page?',
        give_guide_tip: 'Click here to edit complimentary traffic setting!',
        get_it: 'Got it',
        give_set_saved: 'Saved'
    },
    guide: {
        newUser: {
            title: 'Guidelines',
            top_bar: {
                device: 'I want to use the device network',
                sim: 'I want to use the SIM card network'
            },
            step: {
                title: 'How to use the device to access the internet?',
                bind_device: 'Bind device',
                buy_package: 'Purchase data',
                use: 'Get started'
            },
            sub_bar: {
                device: 'Device',
                package: 'Data',
                use: 'Start'
            },
            content: {
                device: {
                    title: 'How to bind device?',
                    q1: '1.Follow the instructions in your device documentation',
                    q2: '2.Check the QR Code on your device (For device with screen: shown on the home screen - More settings)',
                    q3: '3.Click bind button to bind device on the app homepage'
                },
                package: {
                    title: 'How to purchase data package?',
                    q1: '1.View product information on Data Store homepage',
                    q2: '2.Click purchase button to buy it'
                },
                use: {
                    title: 'How do I start to access the Internet?',
                    q1: '1.After a local service data package is purchased, it will be activated automatically when you turn on the device (Restart the device that has been started)',
                    q2: '2.After a global service data package is purchased, it will be activated automatically when you turn on the device at your destination. After the device is successfully connected to the Internet, you can access the Internet freely.',
                    q2_desc: '(It will take 2-3 minutes to connect to the Internet for the first time, please wait patiently)'
                },
                sim: {
                    title: 'How to access the Internet with SIM card?',
                    q1: '1. Insert available SIM card into the device card slot according to the instructions and restart the device for normal operation (For device with screen: you need to switch to SIM card mode on the screen)',
                    q2: '2.You can also connect to device WIFI with cellphone. Click SIM function to switch to SIM Mode on your App Detail Page'
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/lang/fr-FR.js